<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="sd/so/getCriticalComponent">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="扫描时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginScanDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endScanDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
          <vm-search label="订单号">
            <el-input v-model.trim="filter.orders" clearable/>
          </vm-search>
          <vm-search label="合同号">
            <el-input v-model.trim="filter.externContact" clearable/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.factoryNum" clearable/>
          </vm-search>
          <vm-search label="销售订单号">
            <el-input v-model.trim="filter.saleOrderNo" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="saleOrderNo" width="100x" align="center" label="销售订单号"/>
      <el-table-column prop="factoryNum" width="100x" align="center" label="出厂编号"/>
      <el-table-column prop="externContact" width="130x" align="center" label="合同号"/>
      <el-table-column prop="customerName" width="190x" align="center" label="客户名称"/>
      <el-table-column prop="deliveryDate" width="90x" align="center" label="交货日期">
        <template slot-scope="scope">
          <span>
            {{scope.row.deliveryDate.substring(0,10)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="partsBarCode" width="250px" align="center" label="关键部件序列号"/>
      <el-table-column prop="procurementInspection" width="250px" align="center" label="关键部件描述"/>
      <el-table-column prop="cabinetCode" width="250px" align="center" label="控制柜条码序列号"/>
      <el-table-column prop="process" width="50px" align="center" label="工序"/>
      <el-table-column width="90x" prop="materialNo" align="center" label="物料号"/>
      <el-table-column prop="materialDescription" width="250px" align="center" label="物料描述"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch";

  export default {
    name: "CriticalComponentList",
    components: {VmTable, VmSearch},
    data() {
      return {
        filter: {
          saleOrderNo: "",
          factoryNum: "",
          externContact: "",
          orders: "",
          beginScanDate: "",
          endScanDate: "",
        },
      };
    },
    mounted() {
      this.initTime();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      initTime() {
        this.filter.endScanDate = this.getFormatDate(new Date());
        this.filter.beginScanDate = this.getFormatDate(new Date());
        this.$refs.vmTable.getList(1);
      },
      // 获取当前时间
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
    },
  };
</script>

<style scoped>

</style>
